// extracted by mini-css-extract-plugin
module.exports = {"checkInButton":"clinical-portal-3__us-ehr__checkInButton","examButton":"clinical-portal-3__us-ehr__examButton"};